import React, { useEffect, useState } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { deacService } from '../../services/central-api/deac';
import { StyleProp, TextStyle } from 'react-native';

interface Props {
    label: string;
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
    actingBodyId: number;
    actingBodyUnitId?: number;
    zIndex: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
}

function UserDropdown({ label, value, setValue, zIndex, actingBodyId, actingBodyUnitId, labelStyle, viewStyle }: Props) {
    const [users, setUsers] = useState<{ label: string; value: number; }[]>([]);

    async function getUsers() {
        try {
            const users = await deacService.getUsers({
                actingBodyId: actingBodyId,
                actingBodyUnitId: actingBodyUnitId != 0 ? actingBodyUnitId : undefined
            });
            setUsers(users.map((user) => {
                return {
                    value: user.id,
                    label: user.warName && user.warName !== '' ? user.warName : user.name,
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (actingBodyId > 0) {
            getUsers();
        }
    }, [actingBodyId, actingBodyUnitId]);

    return (
        <FilterDropdown
            label={label}
            items={users}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />
    );
}

export default UserDropdown;
